import { useQuery, UseQueryResult } from 'react-query'
import { ApiError } from 'api/types'
import { CHAT_QUERY_KEY, CHATS_QUERY_KEY } from 'api/queriesKeys'
import { useFetch } from 'providers/FetchProvider'
import { ChatResponse, ChatsResponse } from './types'

const MAX_CHAT_QUERY_ATTEMPTS = 4

const useGetChatsQuery = (): UseQueryResult<ChatsResponse, Error> => {
  const { fetch } = useFetch()

  return useQuery(
    CHATS_QUERY_KEY,
    () => fetch.get<ChatsResponse>('/chats').then((response) => response.data),
  )
}

const useGetChatQuery = (chatId?: string, enabled = true) => {
  const { fetch } = useFetch()

  return useQuery<ChatResponse, ApiError>(
    [CHAT_QUERY_KEY, chatId],
    () => fetch.get<ChatResponse>(`/chats/${chatId}`).then((response) => response.data),
    {
      enabled: !!chatId && enabled,
      retry: (failedCount, error) => error.response?.status !== 404
        && failedCount < MAX_CHAT_QUERY_ATTEMPTS,
    },
  )
}

export { useGetChatsQuery, useGetChatQuery }
